meedy.factory('meedy.userModel', ['$rootScope', '$q', 'applicationModel', 'meedy.baseModel', 'meedy.userService',
	function ($rootScope, $q, applicationModel, baseModel, userService) {
		
		function MeedyUserModel() {
			
			var self = this;
			
			this.currentUser = null;
			this.currentMedicalPost = null;
			this.userListCriteria = null;
			this.selectedLanguage = localStorage.getItem('lang');
			this.userHasRightForALAB = null;
			
			this.getDataPage = function (criteria) {
				userService.getDataPage(criteria).then(
					function (dataPage) {
						$rootScope.$broadcast(Event.MEEDY.USER.GET_DATA_PAGE.SUCCESS, dataPage);
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.GET_DATA_PAGE.ERROR, error);
					}
				)
			};
			
			this.usersAvailableForLoggedUser = function (criteria) {
				userService.usersAvailableForLoggedUser(criteria).then(
					function (dataPage) {
						$rootScope.$broadcast(Event.MEEDY.USER.USERS_AVAILABLE_FOR_LOGGED_USER.SUCCESS, dataPage);
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.USERS_AVAILABLE_FOR_LOGGED_USER.ERROR, error);
					}
				)
			};
			
			this.getById = function (id) {
				userService.getById(id).then(
					function (user) {
						$rootScope.$broadcast(Event.MEEDY.USER.GET_BY_ID.SUCCESS, user);
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.GET_BY_ID.ERROR, error);
					}
				)
			};
			
			
			this.save = function (user) {
				applicationModel.actionInProgress = true;
				userService.save(user).then(
					function (savedUser) {
						$rootScope.$broadcast(Event.MEEDY.USER.SAVE.SUCCESS, savedUser);
						baseModel.broadcastOperationSucceeded();
						applicationModel.actionInProgress = false;
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.SAVE.ERROR, error);
						
						if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.ERROR_CODE.DUPLICATED_USER_LOGIN) {
							$rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.DUPLICATED_USER_LOGIN'));
						} else if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.ERROR_CODE.DUPLICATED_USER_EMAIL) {
							$rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.DUPLICATED_USER_EMAIL'));
						}
						
						applicationModel.actionInProgress = false;
					}
				)
			};
			
			this.passwordExpired = function () {
				return userService.passwordExpired().then(
					function (data) {
						$rootScope.$broadcast(Event.MEEDY.USER.PASSWORD_EXPIRED.SUCCESS, data);
						return data;
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.PASSWORD_EXPIRED.ERROR, error);
						$q.reject(error);
					}
				)
			};
			
			this.create = function (user) {
				applicationModel.actionInProgress = true;
				userService.create(user).then(
					function (savedUser) {
						$rootScope.$broadcast(Event.MEEDY.USER.CREATE.SUCCESS, savedUser);
						baseModel.broadcastOperationSucceeded();
						applicationModel.actionInProgress = false;
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.CREATE.ERROR, error);
						
						if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.ERROR_CODE.DUPLICATED_USER_LOGIN) {
							$rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.DUPLICATED_USER_LOGIN'));
						} else if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.ERROR_CODE.DUPLICATED_USER_EMAIL) {
							$rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.DUPLICATED_USER_EMAIL'));
						}
						
						applicationModel.actionInProgress = false;
					}
				)
			};
			
			this.update = function (user) {
				userService.update(user).then(
					function (updatedUser) {
						$rootScope.$broadcast(Event.MEEDY.USER.UPDATE.SUCCESS, updatedUser);
						baseModel.broadcastOperationSucceeded();
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.UPDATE.ERROR, error);
						
						if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.ERROR_CODE.DUPLICATED_USER_LOGIN) {
							$rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.DUPLICATED_USER_LOGIN'));
						} else if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.ERROR_CODE.DUPLICATED_USER_EMAIL) {
							$rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.DUPLICATED_USER_EMAIL'));
						}
					}
				)
			};
			
			this.updatePartnerUser = function (user) {
				userService.updatePartnerUser(user).then(
					function (updatedUser) {
						$rootScope.$broadcast(Event.MEEDY.USER.UPDATE_PARTNER_USER.SUCCESS, updatedUser);
						baseModel.broadcastOperationSucceeded();
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.UPDATE_PARTNER_USER.ERROR, error);
						
						if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.ERROR_CODE.DUPLICATED_USER_LOGIN) {
							$rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.DUPLICATED_USER_LOGIN'));
						} else if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.ERROR_CODE.DUPLICATED_USER_EMAIL) {
							$rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.DUPLICATED_USER_EMAIL'));
						}
					}
				)
			};
			
			this.deleteAll = function (users) {
				userService.deleteAll(users).then(
					function (data) {
						$rootScope.$broadcast(Event.MEEDY.USER.DELETE_ALL.SUCCESS, data);
						baseModel.broadcastOperationSucceeded();
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.DELETE_ALL.ERROR, error);
						baseModel.broadcastOperationFailed();
					}
				)
			};
			
			this.delete = function (userId) {
				userService.delete(userId).then(
					function (data) {
						$rootScope.$broadcast(Event.MEEDY.USER.DELETE.SUCCESS, data);
						baseModel.broadcastOperationSucceeded();
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.DELETE.ERROR, error);
						baseModel.broadcastOperationFailed();
					}
				)
			};
			
			this.updateStatus = function (user) {
				userService.updateStatus(user).then(
					function (data) {
						$rootScope.$broadcast(Event.MEEDY.USER.UPDATE_STATUS.SUCCESS, data);
						baseModel.broadcastOperationSucceeded();
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.UPDATE_STATUS.ERROR, error);
						baseModel.broadcastOperationFailed();
					}
				)
			};
			
			this.accept = function (firstLoginUser) {
				userService.accept(firstLoginUser).then(
					function (data) {
						$rootScope.$broadcast(Event.MEEDY.USER.ACCEPT.SUCCESS, data);
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.ACCEPT.ERROR, error);
						baseModel.broadcastOperationFailed();
					}
				)
			};
			
			this.changePassword = function (oldPassword, newPassword) {
				userService.changePassword(oldPassword, newPassword).then(
					function (user) {
						self.currentUser = user;
						
						$rootScope.$broadcast(Event.MEEDY.USER.CHANGE_PASSWORD.SUCCESS, user);
						baseModel.broadcastOperationSucceeded();
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.CHANGE_PASSWORD.ERROR, error);
						
						if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.ERROR_CODE.PASSWORD_POLICY_VIOLATION) {
							$rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.PASSWORD_POLICY_VIOLATION'));
						}
						else if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.ERROR_CODE.INCORRECT_OLD_PASSWORD) {
							$rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.INCORRECT_OLD_PASSWORD'));
						}
						else {
							baseModel.broadcastOperationFailed();
						}
					}
				)
			};
			
			this.confirmCreation = function (password, token) {
				userService.confirmCreation(password, token).then(
					function (user) {
						$rootScope.$broadcast(Event.MEEDY.USER.CONFIRM_CREATION.SUCCESS, user);
						baseModel.broadcastOperationSucceeded();
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.CONFIRM_CREATION.ERROR, error);
						
						if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.ERROR_CODE.PASSWORD_POLICY_VIOLATION) {
							$rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.PASSWORD_POLICY_VIOLATION'));
						}
						else if (error.headers(Constant.MEEDY.ERROR_HEADER.CODE) === Enum.ERROR_CODE.INCORRECT_OLD_PASSWORD) {
							$rootScope.$broadcast(Event.ERROR, new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.INCORRECT_OLD_PASSWORD'));
						}
						else {
							baseModel.broadcastOperationFailed();
						}
					}
				)
			};
			
			this.validateUserPartnerToken = function (token) {
				userService.validateUserPartnerToken(token).then(
					function (data) {
						$rootScope.$broadcast(Event.MEEDY.USER.VALIDATE_USER_PARTNER_TOKEN.SUCCESS, data);
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.VALIDATE_USER_PARTNER_TOKEN.ERROR, error);
					}
				)
			};
			
			this.remindPassword = function (mail) {
				userService.remindPassword(mail).then(
					function (data) {
						$rootScope.$broadcast(Event.MEEDY.USER.REMIND_PASSWORD.SUCCESS, data);
						baseModel.broadcastOperationSucceeded();
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.REMIND_PASSWORD.ERROR, error);
						baseModel.broadcastOperationFailed();
					}
				)
			};
			
			this.getLoggedUser = function () {
				return userService.getLoggedUser().then(
					function (loggedUser) {
						self.currentUser = loggedUser;
						self.currentMedicalPost = loggedUser.medicalPost;

						$rootScope.$broadcast(Event.MEEDY.USER.GET_LOGGED_USER.SUCCESS, loggedUser);
						return loggedUser;
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.GET_LOGGED_USER.ERROR, error);
						return $q.reject(error);
					}
				)
			};
			
			this.getMyData = function () {
				userService.getMyData().then(
					function (userDetails) {
						$rootScope.$broadcast(Event.MEEDY.USER.GET_MY_DATA.SUCCESS, userDetails);
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.GET_MY_DATA.ERROR, error);
					}
				)
			};
			
			this.updateMyData = function (physicianDetails) {
				userService.updateMyData(physicianDetails).then(
					function (physicianDetails) {
						$rootScope.$broadcast(Event.MEEDY.USER.UPDATE_MY_DATA.SUCCESS, physicianDetails);
						baseModel.broadcastOperationSucceeded();
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.UPDATE_MY_DATA.ERROR, error);
						baseModel.broadcastOperationFailed();
					}
				)
			};
			
			this.uploadMyPicture = function (picture, skipBroadcast) {
				userService.uploadMyPicture(picture).then(
					function () {
						$rootScope.$broadcast(Event.MEEDY.USER.UPLOAD_MY_PICTURE.SUCCESS);
						
						if (skipBroadcast) {
							return;
						}
						
						baseModel.broadcastOperationSucceeded();
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.UPLOAD_MY_PICTURE.ERROR, error);
						
						if (skipBroadcast) {
							return;
						}
						
						baseModel.broadcastOperationFailed();
					}
				)
			};
			
			this.deleteMyPicture = function () {
				userService.deleteMyPicture().then(
					function () {
						$rootScope.$broadcast(Event.MEEDY.USER.DELETE_MY_PICTURE.SUCCESS);
						baseModel.broadcastOperationSucceeded();
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.DELETE_MY_PICTURE.ERROR, error);
						baseModel.broadcastOperationFailed();
					}
				)
			};

			this.addNfzContract = function (contractNumber, nfzBranch) {
				return userService.addNfzContract(contractNumber, nfzBranch);
			};

			this.deleteNfzContract = function (id) {
				return userService.deleteNfzContract(id);
			};

			this.uploadUserCertificate = function (certificate) {
				return userService.uploadUserCertificate(certificate);
			};

			this.deleteUserCertificate = function () {
				return userService.deleteUserCertificate();
			};
			this.uploadMedicalCertificates = function (medicalCertificateTLS, medicalCertificateWSS, password) {
				return userService.uploadMedicalCertificates(medicalCertificateTLS, medicalCertificateWSS, password);
			};

			this.deleteMedicalCertificates = function () {
				return userService.deleteMedicalCertificates();
			};
			
			this.confirmPhysician = function (uuid) {
				userService.confirmPhysician(uuid).then(
					function (userDetails) {
						$rootScope.$broadcast(Event.MEEDY.USER.CONFIRM_PHYSICIAN.SUCCESS, userDetails);
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.CONFIRM_PHYSICIAN.ERROR, error);
					}
				)
			};
			
			this.sendActivationLink = function (idUser) {
				userService.sendActivationLink(idUser).then(
					function (userDetails) {
						baseModel.broadcastOperationSucceeded();
						$rootScope.$broadcast(Event.MEEDY.USER.SEND_ACTIVATION_LINK.SUCCESS, userDetails);
					},
					function (error) {
						baseModel.broadcastOperationFailed();
						$rootScope.$broadcast(Event.MEEDY.USER.SEND_ACTIVATION_LINK.ERROR, error);
					}
				)
			};
			
			this.pwzExistence = function (pwz) {
				userService.pwzExistence(pwz).then(
					function (answer) {
						$rootScope.$broadcast(Event.MEEDY.USER.PWZ_EXISTENCE.SUCCESS, answer);
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.PWZ_EXISTENCE.ERROR, error);
					}
				)
			};
			
			this.getRoleList = function (criteria) {
				userService.getRoleList(criteria).then(
					function (list) {
						$rootScope.$broadcast(Event.MEEDY.USER.GET_ROLE_LIST.SUCCESS, list);
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.GET_ROLE_LIST.ERROR, error);
					}
				)
			};
			
			this.alabIntegrationAvailable = function () {
				return userService.alabIntegrationAvailable().then(
					function (value) {
						self.userHasRightForALAB = value;
						$rootScope.$broadcast(Event.MEEDY.USER.ALAB_INTEGRATION_AVAILABLE.SUCCESS, value);
						return value;
					},
					function (error) {
						$rootScope.$broadcast(Event.MEEDY.USER.ALAB_INTEGRATION_AVAILABLE.ERROR, error);
						return $q.reject(error);
					}
				)
			};
			
			this.userHasRight = function (rightName) {
				var foundRight = _.find(self.currentUser.authorities, function (right) {
					return (right.authority === ('ROLE_' + rightName));
				});
				
				return foundRight ? true : false;
			};
			
			$rootScope.$on(Event.MEEDY.MODULE_CHANGED, function (event, fromModule, toModule) {
				if (fromModule == Constant.MEEDY.MODULE.USERS) {
					self.userListCriteria = null;
				}
			});
		}
		
		return new MeedyUserModel();
	}
]);
